import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MyFamilyFirstBooking from '../../../common/myFamilyFirstBookings'
import SearchBar from '../../../common/commonSearchBar';
import MyFamilyFirstMoreInfoModal from '../../gifts/myFamilyFirst/myFamilyFirstMoreInfoModal';
import Pagination from '../../../common/pagination';
import * as WeddingAction from '../../../actions/weddingAction'
import ClosedModal from '../closeRequestModal';
import { closeRequestInputVal } from '../../../actions/holidayRequestAction';

const Confirmed = ({status}) => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [ searchVal, setSearchVal ] = useState('');
    const [page, setPage] = useState(1);
    const [id, setId] = useState(null);
    const [confirmedMoreInfoModalData, setConfirmedMoreInfoModalData] = useState({});
    const weddingConfirmedData = useSelector(state => state.wedding?.weddingConfirmed?.results);
   const [averageOrderValue,setAverageOrderValue]=useState()
    const[totalOrderValue,setTotalOrderValue]=useState()
    const [requestModal, setRequestModal] = useState(false);
    const [closeRequestModalData, setCloseRequestModalData] = useState({});
    const [isclosingMessageBool, setIsclosingMessageBool] = useState(null);
    const closeRequestMessage = useSelector(state => state.holidayRequest.closeRequestMsg);
    const totalPage = useSelector(state => state.wedding?.weddingConfirmed?.total_pages);
    const START_DATE = useSelector(state => state.wedding.startDate);
    const END_DATE = useSelector(state => state.wedding.endDate);
    const SEARCH_TERM = useSelector(state => state.wedding.searchTerm);
    const PAGE_NO = useSelector(state => state.wedding.pageNo);

    

    useEffect(() => {
       
        let value = [];
        weddingConfirmedData?.map((elem) => {
          if (elem.price) {
            value.push(elem.price)
         
          }
        
        },);
        const valueSum=value.reduce((acc,elem)=>{
            return acc+elem
    
        },0)
       
        setTotalOrderValue(valueSum)
            setAverageOrderValue(Math.round(valueSum/weddingConfirmedData?.length));
      
      }, [weddingConfirmedData]);
     
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => document.body.style.overflow = 'unset';
    }, [showModal]);
    useEffect(() => {
        setPage(1)
      }, [status])
    const handleMoreInfoClick = (data) => {
        setShowModal(true);
        setConfirmedMoreInfoModalData(data);
    };

    const requestStatusChange = (event, id,data) => {
        setCloseRequestModalData(data)
        setId(id)
        let status = event.target.value;
if(status === "cancelled")setRequestModal(true);
else{
    dispatch(WeddingAction.weddingRequestStatusChange(status, id,null, refereshList))

}
       
    };
    const refereshList = () => {
        dispatch(WeddingAction.getWeddingRequested(1));
        dispatch(WeddingAction.getWeddingPlanning(1));
        dispatch(WeddingAction.getWeddingConfirmed(page));
        dispatch(WeddingAction.getWeddingCancelled(1));
    };

    const handlePagination = (e, value) => {
        setPage(value);
        dispatch(WeddingAction.setPageNo(value))
        if (SEARCH_TERM || START_DATE || END_DATE) {
            dispatch(WeddingAction.searchWeddingRequests(SEARCH_TERM, START_DATE, END_DATE, "confirmed", value));
        } else {
            dispatch(WeddingAction.getWeddingConfirmed(value));
        }
    };

    const handleChange = (event) => {
        if (event.target.value) {
            dispatch(WeddingAction.searchWeddingRequests(event.target.value, START_DATE, END_DATE, "confirmed", PAGE_NO));
        } else {
            dispatch(WeddingAction.getWeddingConfirmed(1));
            setPage(1);
        }
        dispatch(WeddingAction.setSearchTerm(event.target.value))
    };
    const closeRequestHandler = () => {
 
        setIsclosingMessageBool(false)
        if(closeRequestMessage === "")setIsclosingMessageBool(true)
        else {
            dispatch(WeddingAction.weddingRequestStatusChange("cancelled", id, closeRequestMessage,refereshList))
          setRequestModal(false)
        }
        dispatch(closeRequestInputVal(''));
      };
    
    const notToCancel=()=>{
        setRequestModal(false)
        setIsclosingMessageBool(false);
    
    }

    const weddingConfirmedDisplayData = weddingConfirmedData && weddingConfirmedData.map((data) => (
        <MyFamilyFirstBooking
            locationsPreferred={data.locations_preferred}
            occasion={data.occasion}
            requestedBy={`Requested by ${data.contact_name}`}
            email={data.contact_email}
            contactNum={data.contact_number}
            messageTitle={data.specific_request ? data.specific_request : 'No Message'}
            specialRequest={data.specific_request ? data.specific_request : "N/A"}
            onClick={() => handleMoreInfoClick(data)}
            myFamilyFirstStatusChange={requestStatusChange}
            isConfirmed={true}
            data={data}
            id={data.id}
            refCode={data.ref_id ? `#${data.ref_id}` : "No ref id"}
            value={data.status}
        />
    ));

    return (
        <>
            <SearchBar
                searchVal={SEARCH_TERM}
                handleChange={handleChange}
            />
            {weddingConfirmedData && weddingConfirmedData?.length === 0 &&
                <div className="enquiry-card-holder">No Record Found!</div>
            }
    <p style={{display:"flex",}}><span><b>Total Order Value: {" "} {totalOrderValue} </b> </span>

<span style={{marginLeft:"80px"}}><b> 
Average Order Value: {" "} {averageOrderValue}
</b>
  </span></p>
            {weddingConfirmedDisplayData}
            <MyFamilyFirstMoreInfoModal
                open={showModal}
                close={() => setShowModal(false)}
                modalData={confirmedMoreInfoModalData}
                section={"Wedding Requested"}
                isCancellationMessage={false}
            />
            <Pagination
                totalPage={totalPage}
                page={page}
                onChange={(event, value) => handlePagination(event, value)}
            />
               {requestModal && 
                <ClosedModal 
                  open={requestModal}
                  handleClose={notToCancel}
                  data={closeRequestModalData}
                  isclosingMessage={isclosingMessageBool}
                  closeRequestHandler={closeRequestHandler}
                />
              }
        </>
    );
};

export default Confirmed;
